import React from "react";
import Link from "next/link";
import { getStockPdpUrl } from "../utils/stockUrlUtils";
import { textEllipsis } from "../../ClpStockCards/clpCardConstant";

export interface ICompany {
  symbol: string;
  name?: string;
  sector?: string | null;
  market_cap?: string | null;
  percentage?: number | null;
  token?: number;
  compName?: string;
  exchId?: string;
  formattedSymbol?: string;
  nseToken?: number;
  bseToken?: number;
  exchange?: number;
}

interface CompanyTagProps {
  company: ICompany;
  className?: string;
}

const CompanyTag: React.FC<CompanyTagProps> = ({ company, className = '' }) => {
  // Handle undefined or null percentage
  const hasPercentage = company.percentage !== undefined && company.percentage !== null;
  const percentage = company.percentage ?? 0;
  const isPositive = percentage >= 0;
  const sign = isPositive ? '+' : '';
  const percentageDisplay = hasPercentage
    ? `${sign}${percentage.toFixed(2)}%`
    : null;

  const stockUrl = getStockPdpUrl(company.symbol);
  const companyDisplayName = (company.compName ?? company.name ?? company.symbol ?? "")
    .replace(/\s+/g, " ")
    .trim();

  return (
    <Link
      href={stockUrl}
      className={`h-[24px] md:h-[28px] flex items-center gap-[10px] py-1 px-2 rounded-[20px] border border-[#E5E5E5] bg-white hover:border-[#FF6700] transition-colors ${className}`}
      aria-label={`View ${company.symbol} stock details`}
    >
      <span className="font-rubik font-normal text-[12px] leading-5 tracking-[0px] align-middle text-[#1A1A1A] md:hidden">
        {textEllipsis(company?.symbol ?? "", 4)}
      </span>
      <span className="hidden font-rubik font-normal text-[14px] leading-5 tracking-[0px] align-middle text-[#1A1A1A] md:inline">
        {textEllipsis(company?.symbol ?? "", 12)}
      </span>
      {percentageDisplay && (
        <span
          className={`font-rubik font-normal text-[12px] md:text-[14px] leading-5 tracking-[0px] align-middle ${isPositive ? 'text-[#067161]' : 'text-red-500'
            }`}
        >
          {percentageDisplay}
        </span>
      )}
    </Link>
  );
};

export default CompanyTag;

